var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-50"},[_c('el-steps',{attrs:{"active":1}},[_c('el-step',{attrs:{"title":"Step 1","icon":"el-icon-edit"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Step 2","icon":"el-icon-upload"}}),_vm._v(" "),_c('el-step',{attrs:{"title":"Step 3","icon":"el-icon-picture"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }